import { schema } from "normalizr";
import { ShippingCarrier } from "./shipping-carrier";

export const ShippingCarriers = new schema.Array(ShippingCarrier);
